<template>
  <div class="card-container">
    <div class="card">
      <i class="close" @click="$emit('close')"/>
      <h3 class="card-hd">{{ item.question }}</h3>
      <div class="card-bd">
        <div class="bd-l">
          <loop-pic v-if="item.album" :pic-arr="item.album"/>
          <img v-else-if="item.photo" :src="require(`../../assets${item.photo}`)" alt="图片">
          <d-player v-else-if="item.video" :url="require(`../../assets${item.video}`)" :volume="0"/>
          <div v-else class="audio-wrap">
            <img class="cover" :src="require(`../../assets${item.audio.cover}`)" alt="cover">
            <i alt="icon" class="icon" :class="playing ? 'pause' : 'play'" title="播放音频" @click="playAudio(item.audio.src)"/>
            <p>{{ item.audio.des }}</p>
          </div>
        </div>
        <div class="bd-r">
          <p v-for="(p, i) in item.answer" :key="i">{{ p }}</p>
        </div>
      </div>
    </div>
    <guide-button class="btn-rt" @click="$emit('close')">继续</guide-button>
  </div>
</template>

<script>

export default {
  name: 'Card',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      playing: false,
    }
  },
  methods: {
    playAudio (src) {
      if (this.playing) {
        this.$emit('pause-audio')
      } else {
        this.$emit('play-audio', src, false)
      }
      this.playing = !this.playing
    },
  },
}
</script>

<style lang="scss" scoped>
.card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .card {
    position: relative;
    width: 13rem;
    height: 7rem;
    padding: 0.001rem 0.25rem 0.001rem 0.5rem;
    background-image: url(../../assets/wiki/img/wiki-card-bg.png);
    background-size: 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    .close {
      position: absolute;
      top: -0.5rem;
      right: -0.5rem;
      display: inline-block;
      width: 0.5rem;
      height: 0.5rem;
      background-image: url(../../assets/img/icon/close.png);
      background-repeat: no-repeat;
      background-size: contain;
      cursor: pointer;
      z-index: 12;
    }
    &-hd {
      margin: 0.5rem 0;
      font-size: 0.4rem;
      font-weight: bold;
      color: #2b4e8a;
      text-align: center;
    }
    &-bd {
      .bd-l,
      .bd-r {
        display: inline-block;
        width: 50%;
        max-height: 5.1rem;
        vertical-align: top;
        overflow: auto;
      }
      .bd-l {
        font-size: 0;
        text-align: center;
        .v-player {
          font-size: 0.12rem;
        }
        .dplayer-fulled {
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
        }
        .audio-wrap {
          position: relative;
          margin: 0.5rem auto;
          .cover {
            width: 100%;
          }
          .icon {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            width: 1rem;
            height: 1rem;
            margin: auto;
            cursor: pointer;
            &.play {
              background-image: url(./play.png);
            }
            &.pause {
              background-image: url(./pause.png);
            }
            background-size: cover;
          }
          p {
            margin-top: 0.1rem;
            font-size: 0.2rem;
            color: #333;
          }
        }
      }
      .bd-r {
        padding: 0 0.2rem 0 0.3rem;
        box-sizing: border-box;
        &::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 0.1rem; /*高宽分别对应横竖滚动条的尺寸*/
          height: 0.1rem;
        }
        &::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 0.08rem;
          background: #4586d8;
        }
        &::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          border-radius: 0;
          background: #c1d0e4;
        }
      }
      .bd-r > p {
        font-size: 0.22rem;
        line-height: 2;
        text-indent: 0.44rem;
        color: #46485b;
      }
    }
  }
}
</style>
